<app-galapagospro *ngIf="company=='galapagospro'" (headerHeight)="getHeight($event)"
    (headerHeight)="getHeight1($event)"></app-galapagospro>
<app-galavail *ngIf="company=='galavail'"></app-galavail>
<app-fourworldstravels *ngIf="company=='fourworldstravels'" (headerHeight)="getHeight($event)"
    (headerHeight1)="getHeight1($event)"></app-fourworldstravels>
<app-fusiontravelecuador *ngIf="company=='fusiontravelecuador'" (headerHeight)="getHeight($event)"
    (headerHeight1)="getHeight1($event)"></app-fusiontravelecuador>
<app-galapagosde *ngIf="company=='galapagosde'" (headerHeight)="getHeight($event)"
    (headerHeight)="getHeight1($event)"></app-galapagosde>
<app-globallandtour *ngIf="company=='globallandtour'" (headerHeight)="getHeight($event)"
    (headerHeight)="getHeight1($event)"></app-globallandtour>
<app-galapagosinsiders *ngIf="company=='galapagosinsiders'" (headerHeight)="getHeight($event)"
    (headerHeight)="getHeight1($event)"></app-galapagosinsiders>
<app-hakuadventure *ngIf="company=='hakuadventure'" (headerHeight1)="getHeight1($event)"
    (headerHeight)="getHeight($event)"></app-hakuadventure>
<app-adventurejourneys *ngIf="company=='adventurejourneys'" (headerHeight)="getHeight($event)"
    (headerHeight1)="getHeight1($event)"></app-adventurejourneys>
<app-mytriptoecuador *ngIf="company=='mytriptoecuador'" (headerHeight)="getHeight($event)"
    (headerHeight1)="getHeight1($event)"></app-mytriptoecuador>
<app-camiadventures *ngIf="company=='camiadventures'" (headerHeight)="getHeight($event)"
    (headerHeight1)="getHeight1($event)"></app-camiadventures>
<app-ecuatraveling *ngIf="company=='ecuatraveling'" (headerHeight)="getHeight($event)"
    (headerHeight)="getHeight1($event)"></app-ecuatraveling>
<app-quitobiketours *ngIf="company=='quitobiketours'" (headerHeight)="getHeight($event)"
    (headerHeight1)="getHeight1($event)"></app-quitobiketours>
<app-galatrails *ngIf="company=='galatrails'" (headerHeight)="getHeight($event)"
    (headerHeight1)="getHeight1($event)"></app-galatrails>
<app-quitotourbus *ngIf="company=='quitotourbus'" (headerHeight)="getHeight($event)"
    (headerHeight)="getHeight1($event)"></app-quitotourbus>
<app-quichuanativetravel *ngIf="company=='quichuanativetravel'" (headerHeight)="getHeight($event)"
    (headerHeight1)="getHeight1($event)"></app-quichuanativetravel>
<app-naturegalapagos *ngIf="company=='naturegalapagos'" (headerHeight)="getHeight($event)"
    (headerHeight1)="getHeight1($event)"></app-naturegalapagos>
<app-imagineecuador *ngIf="company=='imagineecuador'" (headerHeight1)="getHeight1($event)"
    (headerHeight)="getHeight($event)"></app-imagineecuador>
<app-galapagoslastminutes *ngIf="company=='galapagoslastminutes'" (headerHeight)="getHeight($event)"
    (headerHeight)="getHeight1($event)"></app-galapagoslastminutes>
<app-surtrek *ngIf="company=='surtrek'" (headerHeight)="getHeight($event)"
    (headerHeight1)="getHeight1($event)"></app-surtrek>
<app-equatorexpeditions *ngIf="company=='equatorexpeditions'" (headerHeight)="getHeight($event)"
    (headerHeight)="getHeight1($event)"></app-equatorexpeditions>
<app-ecuadorfamilytours *ngIf="company=='ecuadorfamilytours'" (headerHeight)="getHeight($event)"
    (headerHeight1)="getHeight1($event)"></app-ecuadorfamilytours>
<app-carpedm *ngIf="company=='carpedm'" (headerHeight)="getHeight($event)"
    (headerHeight)="getHeight1($event)"></app-carpedm>
<app-carpedmadventures *ngIf="company=='carpedmadventures'" (headerHeight)="getHeight($event)"
    (headerHeight1)="getHeight1($event)"></app-carpedmadventures>
<app-gulliverexpeditions *ngIf="company=='gulliverexpeditions'" (headerHeight)="getHeight($event)"
    (headerHeight)="getHeight1($event)"></app-gulliverexpeditions>
<app-antarcticbookingcenter *ngIf="company=='antarcticbookingcenter'" (headerHeight)="getHeight($event)"
    (headerHeight)="getHeight1($event)"></app-antarcticbookingcenter>
<app-takiritravel *ngIf="company=='takiritravel'" (headerHeight)="getHeight($event)"
    (headerHeight)="getHeight1($event)"></app-takiritravel>
<app-columbustravelecuador *ngIf="company=='columbustravelecuador'" (headerHeight)="getHeight($event)"
    (headerHeight)="getHeight1($event)"></app-columbustravelecuador>
<app-galapagosluxurycruises *ngIf="company=='galapagosluxurycruises'" (headerHeight)="getHeight($event)"
    (headerHeight)="getHeight1($event)"></app-galapagosluxurycruises>
<app-discoverygalapagos *ngIf="company=='discoverygalapagos'" (headerHeight)="getHeight($event)"
    (headerHeight1)="getHeight1($event)"></app-discoverygalapagos>
<app-ecuadortierradefuego *ngIf="company=='ecuadortierradefuego'" (headerHeight)="getHeight($event)"
    (headerHeight1)="getHeight1($event)"></app-ecuadortierradefuego>
<app-handmadetravel *ngIf="company=='handmadetravel'" (headerHeight)="getHeight($event)"
    (headerHeight)="getHeight1($event)"></app-handmadetravel>
<app-volcanicparadisegalapagos *ngIf="company=='volcanicparadisegalapagos'" (headerHeight)="getHeight($event)"
    (headerHeight1)="getHeight1($event)"></app-volcanicparadisegalapagos>
<app-latamretreats *ngIf="company=='latamretreats'" (headerHeight)="getHeight($event)"
    (headerHeight1)="getHeight1($event)"></app-latamretreats>
<app-galapagosdreams *ngIf="company=='galapagosdreams'" (headerHeight)="getHeight($event)"
    (headerHeight1)="getHeight1($event)"></app-galapagosdreams>
<app-midlandtravel *ngIf="company=='midlandtravel'" (headerHeight)="getHeight($event)"
    (headerHeight1)="getHeight1($event)"></app-midlandtravel>
<app-linkexperiences *ngIf="company=='linkexperiences'" (headerHeight)="getHeight($event)"
    (headerHeight1)="getHeight1($event)"></app-linkexperiences>
<app-scubaiguana *ngIf="company=='scubaiguana'" (headerHeight)="getHeight($event)"
    (headerHeight1)="getHeight1($event)"></app-scubaiguana>
<app-galaapp *ngIf="company=='galaapp'" (headerHeight)="getHeight($event)"
    (headerHeight1)="getHeight1($event)"></app-galaapp>
<app-galapagoseden *ngIf="company=='galapagoseden'" (headerHeight)="getHeight($event)"
    (headerHeight)="getHeight1($event)"></app-galapagoseden>
<app-galapagosdestinytours *ngIf="company=='galapagosdestinytours'" (headerHeight)="getHeight($event)"
    (headerHeight)="getHeight1($event)"></app-galapagosdestinytours>
<app-luxuryprivatejourneys *ngIf="company=='luxuryprivatejourneys'" (headerHeight)="getHeight($event)"
    (headerHeight)="getHeight1($event)"></app-luxuryprivatejourneys>
<app-papayatours *ngIf="company=='papayatours'" (headerHeight)="getHeight($event)"
    (headerHeight)="getHeight1($event)"></app-papayatours>
<app-rebeccaadventuretravel *ngIf="company=='rebeccaadventuretravel'" (headerHeight)="getHeight($event)"
    (headerHeight)="getHeight1($event)"></app-rebeccaadventuretravel>
<app-gettravelgalapagos *ngIf="company=='gettravelgalapagos'" (headerHeight)="getHeight($event)"
    (headerHeight)="getHeight1($event)"></app-gettravelgalapagos>
<app-galapagostrails *ngIf="company=='galapagostrails'" (headerHeight)="getHeight($event)"
    (headerHeight)="getHeight1($event)"></app-galapagostrails>